import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import {
  STEP_TESTS,
  STEPS_CONTENT,
} from '@core/devices/constants/devicesSteps';
import {
  DTSpeakerIcon,
  DTMicroIcon,
  CheckCircleIcon,
  DTVideoCameraIcon,
  DTConnectionIcon,
} from '@icons';
import { useDevicesTestState } from '@core/devices/pages/DevicesTestPage/hooks/state';

import { useStyles } from './styles';

const ProgressSteps = () => {
  const { t: translate } = useTranslation();
  const { step: currentStep } = useDevicesTestState();
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      {STEPS_CONTENT.map((stepContent, i) => {
        const { stepTest } = stepContent();
        const isPastStep = currentStep > i;
        const isCurrentStep = currentStep == i;

        switch (stepTest) {
          case STEP_TESTS.CONNECTION: {
            return (
              <Box key={`${i}_stepcontent`} sx={classes.step}>
                <Box sx={classes.circle(isCurrentStep)}>
                  <DTConnectionIcon sx={classes.stepIcon} />
                  {isPastStep && (
                    <Box sx={classes.pastStepCheck}>
                      <CheckCircleIcon />
                    </Box>
                  )}
                </Box>
                <Typography sx={classes.stepName}>
                  {translate('devicesTest.connectionTest.stepName')}
                </Typography>
              </Box>
            );
          }
          case STEP_TESTS.MICROPHONE: {
            return (
              <Box key={`${i}_stepcontent`} sx={classes.step}>
                <Box sx={classes.circle(isCurrentStep)}>
                  <DTMicroIcon sx={classes.stepIcon} />
                  {isPastStep && (
                    <Box sx={classes.pastStepCheck}>
                      <CheckCircleIcon />
                    </Box>
                  )}
                </Box>
                <Typography sx={classes.stepName}>
                  {translate('devicesTest.microTest.stepName')}
                </Typography>
              </Box>
            );
          }
          case STEP_TESTS.SPEAKER: {
            return (
              <Box key={`${i}_stepcontent`} sx={classes.step}>
                <Box sx={classes.circle(isCurrentStep)}>
                  <DTSpeakerIcon sx={classes.stepIcon} />
                  {isPastStep && (
                    <Box sx={classes.pastStepCheck}>
                      <CheckCircleIcon />
                    </Box>
                  )}
                </Box>
                <Typography sx={classes.stepName}>
                  {translate('devicesTest.speakerTest.stepName')}
                </Typography>
              </Box>
            );
          }
          case STEP_TESTS.WEBCAM: {
            return (
              <Box key={`${i}_stepcontent`} sx={classes.step}>
                <Box sx={classes.circle(isCurrentStep)}>
                  <DTVideoCameraIcon sx={classes.stepIcon} />
                  {isPastStep && (
                    <Box sx={classes.pastStepCheck}>
                      <CheckCircleIcon />
                    </Box>
                  )}
                </Box>
                <Typography sx={classes.stepName}>
                  {translate('devicesTest.webcamTest.stepName')}
                </Typography>
              </Box>
            );
          }
        }
      })}
    </Box>
  );
};

export default ProgressSteps;
